var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_758",
    "data-name": "Group 758",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.571,
    height: 15.757,
    viewBox: "0 0 16.571 15.757",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 16.571,
    height: 15.757,
    fill: "#f5d730"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_757",
    "data-name": "Group 757",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M8.287,0A.667.667,0,0,1,8.91.389q1.057,2.144,2.118,4.286A.2.2,0,0,0,11.2,4.8c.875.123,1.75.251,2.625.378.724.1,1.449.206,2.173.316a.668.668,0,0,1,.36,1.143c-.488.479-.98.954-1.47,1.431q-1.006.979-2.014,1.957a.152.152,0,0,0-.051.154q.4,2.334.8,4.67a1.05,1.05,0,0,1,.005.408.658.658,0,0,1-.955.417c-.555-.286-1.108-.579-1.661-.869q-1.325-.7-2.649-1.393a.161.161,0,0,0-.171.007Q6.069,14.54,3.941,15.655A.673.673,0,0,1,3,15.416.627.627,0,0,1,2.92,15q.247-1.443.494-2.886c.111-.649.225-1.3.332-1.948a.19.19,0,0,0-.059-.137Q2.61,8.971,1.528,7.921C1.087,7.493.645,7.066.206,6.635A.632.632,0,0,1,.037,5.95.642.642,0,0,1,.569,5.5c.194-.035.389-.058.584-.086L4.4,4.941c.328-.048.656-.1.985-.14a.175.175,0,0,0,.151-.113Q6.6,2.539,7.658.392A.669.669,0,0,1,8.287,0",
    transform: "translate(0)",
    fill: "#f5d730"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSmall);
export default __webpack_public_path__ + "static/media/star-small.34a09775b4281a3389a25d36f1621014.svg";
export { ForwardRef as ReactComponent };